
import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment/additional_order`;

export const additionalService = {
 
    getLocationsLookups: async function (loadOptions: any) {
        return axios.get(`${GATEWAY_URL}/locations`, {
        })
            .then((response) => {
                return response.data;
            });
    },

    getSupplierLookups: async function (preOrderId: any) {
        return axios.get(`${GATEWAY_URL}/vendors`, {
            params: {
                PreOrderId: preOrderId
            }
        })
            .then((response) => {
                return response.data;
            });
    },
 
    getProductsLookups: async function (preOrderId: any) {
        return axios.get(`${GATEWAY_URL}/products`, {
            params: {
                PreOrderId: preOrderId
            }
        })
            .then((response) => {
                return response.data;
            });
    },

 
    updatePreorder: async function (key: any, values: any) {
        return axios.post(`${GATEWAY_URL}/approvedqty`, values)
            .then((response) => {
                return response.data;
            });
    },


    updatePreorderBatch: async function (values: any) {
        return axios.put(`${GATEWAY_URL}/qty_approvement`, values)
            .then((response) => {
                return response.data;
            });
    },



     saveAdditionalOrder: async function (values: any) {
        return axios.put(`${GATEWAY_URL}/save_order`, values)
            .then((response) => {
                return response.data;
            });
    },


    getAdditionalDetailList: async function (orderId: any) {
        return axios.get(`${GATEWAY_URL}/lines`, {
            params: { orderId }
        })
            .then((response) => {
                return response.data;
            });
    },

    getAdditional: async function (orderId: any) {
        return axios.get(`${GATEWAY_URL}/get`, {
            params: { orderId }
        })
            .then((response) => {
                return response.data;
            });
    },

     updateAdditionalMaster: async function (values: any) {
        return axios.put(`${GATEWAY_URL}/update_order`, values) 
            .then((response) => {
                return response.data;
            });
    },
     
}

